import React from "react";
import { Alert, Box } from "@mui/material";
import PageShell from "../components/PageShell";
import HospitalListTable from "../lists/HospitalListTable";
import { listHospitals } from "../api/coreApi";
import { normalizeList } from "../utils/coreHelpers";
import { Colors } from "../../utils/Colors"; // keep this if your file name is Colors.js

export default function CoreListPage() {
  const [err, setErr] = React.useState("");
  const [hospitals, setHospitals] = React.useState([]);

  const load = async () => {
    setErr("");
    try {
      const hs = await listHospitals();
      setHospitals(normalizeList(hs.data));
    } catch (e) {
      setErr(
        e?.response?.data
          ? JSON.stringify(e.response.data)
          : "Failed to load hospitals"
      );
    }
  };

  React.useEffect(() => {
    load();
  }, []);

  return (
    <PageShell
      title="Core Lists"
      subtitle="Lists only (no forms here)"
    >
      {/* Wrapper */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        {/* ERROR ALERT */}
        {err && (
          <Alert
            severity="error"
            sx={{
              borderRadius: 2,
              px: 2,
              py: 1,
              fontWeight: 500,
              border: `1px solid ${Colors.status.danger}33`,
              backgroundColor: `${Colors.status.danger}0D`, // soft red bg
              color: Colors.status.danger,

              "& .MuiAlert-icon": {
                color: Colors.status.danger,
              },
            }}
          >
            {err}
          </Alert>
        )}

        {/* TABLE CONTAINER */}
        <Box
          sx={{
            backgroundColor: Colors.bg.paper,
            border: `1px solid ${Colors.border.light}`,
            borderRadius: 3,
            boxShadow: Colors.shadow.brand,
            overflow: "hidden",
          }}
        >
          <HospitalListTable hospitals={hospitals} />
        </Box>
      </Box>
    </PageShell>
  );
}